import React from 'react'
import Topheader from '../../components/Topheader'
import style from './styles.module.css'
export default function PTGeneralQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas Gerais" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  O que é a versão de Jogo Gratuito do PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    A versão de Jogo Gratuito permite que você aproveite toda a emoção do pôquer sem usar dinheiro real. Você joga com fichas gratuitas, ganha Pontos de Recompensa jogando e os resgata na Baazi Store por ofertas e cartões-presente das melhores marcas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Posso usar minha conta atual do PokerBaazi?
                </div>
                <div className={style.sub_text3}>
                    Sim! Você pode fazer login com sua conta atual do PokerBaazi. Se for novo, cadastre-se gratuitamente na Google Play Store ou Apple App Store — não é necessário depósito.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  É possível alternar entre os modos de Jogo Gratuito e Cash?
                </div>
                <div className={style.sub_text3}>
                    Não. O PokerBaazi agora está totalmente focado no Jogo Gratuito — uma experiência de prática prévia e baseada em recompensas onde cada mão contribui para sua progressão.
                </div>
            </div>
        </div>
    )
}


export function PTLeaderboardAndProgression() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Classificações e Progressão" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Como funcionam as classificações?
                </div>
                <div className={style.sub_text3}>
                    As classificações rastreiam seu desempenho em jogos rápidos e torneios. Jogue regularmente para ganhar pontos, subir de ranking e ganhar Pontos de Recompensa bônus toda semana.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Meu ranking na classificação não está atualizando.
                </div>
                <div className={style.sub_text3}>
                    Os rankings são atualizados a cada poucos minutos. Se você não viu a atualização, compartilhe seu nome de usuário conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> e verificaremos para você.
                </div>

            </div>
        </div>
    )
}

export function PTGameplayQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas de Jogo" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  Quais jogos posso jogar?
                </div>
                <div className={style.sub_text3}>
                    Você pode jogar Texas Hold'em, Omaha, All-in or Fold, Super Hold'em e Open Face Poker (OFC) — disponíveis em jogos rápidos e torneios.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Fiquei sem fichas. O que devo fazer?
                </div>
                <div className={style.sub_text3}>
                    Você recebe fichas gratuitas diariamente, de hora em hora e assistindo anúncios. Você também pode ganhar mais completando Recompensas de Tarefas ou se classificando nas tabelas de líderes.
                </div>

            </div>
        </div>
    )
}

export function PTBaaziStore() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Baazi Store" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.   O que é a Baazi Store?
                </div>
                <div className={style.sub_text3}>
                    A Baazi Store é onde você resgata seus Pontos de Recompensa por cupons, ofertas e cartões-presente das melhores marcas — impulsionado pelo Advantage Club.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Resgatei uma recompensa mas não a recebi.
                </div>
                <div className={style.sub_text3}>
                    Os resgates podem levar até 48 horas para serem processados. Se ainda não chegou, compartilhe o nome da recompensa escolhida e a data do resgate conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> e verificaremos imediatamente.

                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Preciso ter um login separado do Advantage Club?
                </div>
                <div className={style.sub_text3}>
                    Não — você faz login automaticamente através do PokerBaazi. Não são necessárias etapas adicionais. <br />
                    Para ofertas premium e drops surpresa, explore a associação Baazi Select.

                </div>


            </div>
        </div>
    )
}
export function PTBaaziSelectMembership() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Membros Baazi Select" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. O que é o Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    O Baazi Select é nossa <strong>assinatura de associação premium</strong> que desbloqueia recursos avançados de jogo, personalizações visuais premium e acesso exclusivo ao Poker TV — incluindo temporadas futuras de <strong>The Circuit</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. O que está incluído no Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    O Baazi Select oferece acesso a:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Avatares premium e temas de mesa</li>
                        <li>Ferramentas de gameplay como Rabbit e Player Stats</li>
                        <li>Configurações de mesa aprimoradas</li>
                        <li>Acesso completo ao Poker TV</li>
                        <li>Ofertas exclusivas e expandidas na Rewards Store</li>
                        <li>Acesso antecipado a próximas experiências premium</li>
                    </ul>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. O Baazi Select dá vantagem no jogo?
                </div>
                <div className={style.sub_text3}>
                    Não. O Baazi Select foi desenvolvido para <strong>melhorar sua experiência e opções de personalização</strong>. Ele não cria vantagens injustas no gameplay nem influencia os resultados do jogo.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Como obtenho o Baazi Select?
                </div>
                <div className={style.sub_text3}>
                    Você pode assinar o Baazi Select em:
                    <ul className='m-0 ps-3 pt-2'>
                        <li><strong>Seção de Associação na tela inicial</strong></li>
                        <li><strong>Perfil → Associação / Configurações</strong></li>
                    </ul>
                    A assinatura é cobrada com segurança pela <strong>Google Play Store / App Store</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. O Baazi Select é uma assinatura com renovação automática?
                </div>
                <div className={style.sub_text3}>
                    Sim. O Baazi Select é renovado automaticamente pela sua <strong>conta Google Play / App Store</strong> ao final de cada ciclo de faturamento, a menos que seja cancelado antes da renovação.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Como cancelo minha associação?
                </div>
                <div className={style.sub_text3}>
                    Você pode cancelar a qualquer momento nas configurações de assinatura do seu dispositivo.<br />
                    <strong>Android:</strong> Google Play → Perfil → Pagamentos e assinaturas → Assinaturas → Baazi Select → Cancelar<br />
                    <strong>iPhone:</strong> Configurações → ID Apple → Assinaturas → Baazi Select → Cancelar
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. O que acontece após o cancelamento?
                </div>
                <div className={style.sub_text3}>
                    Seus benefícios de associação permanecerão ativos até o <strong>final do período de faturamento atual</strong>. Após isso, a assinatura não será renovada e os benefícios premium expirarão.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Desinstalar o aplicativo cancela minha associação?
                </div>
                <div className={style.sub_text3}>
                    Não. Desinstalar o aplicativo não cancela sua assinatura. Para interromper renovações futuras, você deve cancelar nas <strong>configurações de assinatura da Google Play / App Store</strong>.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Como o Baazi Select funciona com os Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    O Baazi Select desbloqueia um <strong>conjunto premium de ofertas exclusivas e cartões-presente das melhores marcas</strong> na Rewards Store. Sem a associação, apenas uma seleção limitada de recompensas está disponível.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Posso obter um reembolso?
                </div>
                <div className={style.sub_text3}>
                    Reembolsos por assinaturas compradas pela <strong>Google Play Store / App Store</strong> devem ser solicitados diretamente na respectiva loja. A aprovação do reembolso está sujeita à política de faturamento da loja.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. O que mais posso esperar?
                </div>
                <div className={style.sub_text3}>
                    O Baazi Select continuará a evoluir com:
                    <ul className='m-0 ps-3 pt-2'>
                        <li>Pacotes surpresa na Baazi Store</li>
                        <li>Novas ferramentas premium e utilidades de gameplay</li>
                        <li>Novos temas e personalizações de mesa</li>
                        <li>Conteúdos exclusivos do Poker TV</li>
                        <li>Temporadas futuras de The Circuit</li>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export function PTTaskRewards() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Recompensas de Tarefas" />
            <div className="main-container mb-5 px-3"><div className={style.sub_text2_q}> Q. O que são as Recompensas de Tarefas?  </div>
                <div className={style.sub_text3}>
                    <p>As Recompensas de Tarefas são desafios diários e semanais que lhe dão fichas ou Pontos de Recompensa ao serem concluídos. Eles ajudam você a progredir mais rapidamente e a se manter engajado com novos objetivos todos os dias. </p>
                </div>
                <div className={style.brd}></div>
                <div className={style.sub_text2_q}>Q. Não recebi minha recompensa de tarefa.  </div>
                <div className={style.sub_text3}>
                    <p>Compartilhe o nome da sua tarefa e o horário de conclusão conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> — garantiremos que seja creditado o mais rápido possível. </p>
                </div>


            </div>
        </div>
    )
}

export function PTTechnicalQueries() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Consultas Técnicas" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q. O app não carrega ou mostra erro de rede.
                </div>
                <div className={style.sub_text3}>
                    Tente fechar e reabrir o app e certifique-se de que sua conexão com a internet esteja estável. Se o problema persistir, envie-nos uma captura de tela e a versão do seu app em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a>
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Perdi a conexão no meio de um jogo.
                </div>
                <div className={style.sub_text3}>
                    Você pode se reconectar à mesma mesa imediatamente se o jogo ainda estiver ativo. Seu progresso e pontos estão seguros.                </div>

            </div>
        </div>
    )
}

export function PTWallet() {
    return (
        <div>
            <Topheader colorbox="newfaq_header_color" title="Carteira" />
            <div className="main-container mb-5 px-3">
                <div className={style.sub_text2_q}>
                    Q.  O que são Fichas?
                </div>
                <div className={style.sub_text3}>
                    As Fichas são sua moeda no jogo usada para jogar partidas de pôquer e torneios. Você pode reivindicá-las diariamente e de hora em hora (a cada 60 minutos) e também pode obtê-las assistindo anúncios ou completando tarefas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Fiquei sem Fichas. O que devo fazer?
                </div>
                <div className={style.sub_text3}>
                    Você pode reivindicar fichas diariamente e de hora em hora (a cada 60 minutos). Você também pode ganhar mais assistindo anúncios ou completando tarefas de recompensa.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  O que são Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Os Pontos de Recompensa são obtidos através do jogo — classificando-se nas tabelas de líderes, terminando em posições de pagamento em torneios ou completando tarefas. Eles podem ser resgatados na Baazi Store por ofertas e cartões-presente das melhores marcas.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Como ganho Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Jogue partidas, suba nas classificações, complete tarefas diárias ou termine em posições de pagamento em torneios para ganhar Pontos de Recompensa.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Como uso os Pontos de Recompensa?
                </div>
                <div className={style.sub_text3}>
                    Abra a Baazi Store no app, escolha sua oferta ou cupom preferido e resgate usando seus Pontos de Recompensa disponíveis.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.   Os Pontos de Recompensa podem ser resgatados por dinheiro?
                </div>
                <div className={style.sub_text3}>
                    Não. Os Pontos de Recompensa só podem ser usados para resgatar ofertas ou cupons na Baazi Store.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q. Resgatei meus Pontos de Recompensa mas não recebi o item.
                </div>
                <div className={style.sub_text3}>
                    Por favor, aguarde até 48 horas para o processamento. Se não receber, entre em contato conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> com o nome da recompensa escolhida e a data do resgate para obter ajuda.
                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Posso transferir Fichas ou Pontos de Recompensa para outro jogador?
                </div>
                <div className={style.sub_text3}>
                    Não. Tanto as Fichas quanto os Pontos de Recompensa não são transferíveis e estão vinculados apenas à sua conta.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Onde posso verificar meus saldos?
                </div>
                <div className={style.sub_text3}>
                    Você pode ver suas Fichas e Pontos de Recompensa na seção de Carteira do app a qualquer momento.                </div>
                <div className={style.brd}></div>

                <div className={style.sub_text2_q}>
                    Q.  Meu saldo não foi atualizado. O que devo fazer?
                </div>
                <div className={style.sub_text3}>
                    Atualize o app ou saia e faça login novamente. Se o problema persistir, entre em contato conosco em <a href='mailto:playerrelations@pokerbaazi.net'>playerrelations@pokerbaazi.net</a> com seu nome de usuário e os detalhes do jogo.               </div>
            </div>
        </div>
    )
}



